/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Details/Actions/ServiceEndpointRequestHistoryActionsHub" />
import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";
import { ServiceEndpointExecutionRecord } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

export interface IServiceEndpointRequestHistoryState {
    serviceEndpointRequestHistoryRecords?: ServiceEndpointExecutionRecord[];
    continuationToken?: number;
    hasMore?: boolean;
    isLoading?: boolean;
}

export class ServiceEndpointRequestHistoryActionsHub extends ActionsHubBase {
    public static getKey(): string {
        return "service-endpoints-history-actions";
    }

    public initialize(): void {
        this._updateState =  new Action<IServiceEndpointRequestHistoryState>();
    }

    public get updateState(): Action<IServiceEndpointRequestHistoryState> {
        return this._updateState;
    }

    private _updateState: Action<IServiceEndpointRequestHistoryState>;
}
